import React from 'react';
import * as XLSX from 'xlsx';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

interface ExportExcelButtonProps {
  rows: any[];
  columns: { field: string; headerName: string }[];
  fileName?: string;

  // 🟩 Accept formatter functions per column
  formatters?: Record<string, (value: any) => any>;
}

const ExportExcelButton: React.FC<ExportExcelButtonProps> = ({
  rows,
  columns,
  fileName = 'rapor',
  formatters = {}, // 🟩 Default empty object
}) => {
  const handleExport = () => {
    const exportData = rows.map((row) => {
      const result: Record<string, any> = {};

      columns.forEach(({ field, headerName }) => {
        const rawValue = row[field];

        // 🟩 If a formatter exists for this field, apply it
        const formattedValue = formatters[field]
          ? formatters[field](rawValue)
          : rawValue;

        result[headerName] = formattedValue;
      });

      return result;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Rapor');

    // 🟦 This triggers download
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <Button
      variant="outlined"
      onClick={handleExport}
      startIcon={<DownloadIcon />}
    >
      Excel'e Aktar
    </Button>
  );
};

export default ExportExcelButton;
